export enum CrewChangeActions {
  APPROVE = 'Approve',
  DECLINE = 'Decline',
  CANCEL = 'Cancel',
}
